import SchemerModel from "./SchemerModel"
import { 
  SCHEMER_FIELDS,
  TABLE_FIELDS,
  ColumnsConfig,
  FieldConfigOutput,
  FieldConfigsOutput,
  ArrayConfigOutput,
  DEFAULT_TABLE_CONFIG
} from "./decorators/constants"
import {
  ARRAY
} from '../core/types/array'


export function getFieldConfig (target: SchemerModel, propName: string) : FieldConfigOutput {

  return Reflect.getMetadata(SCHEMER_FIELDS, target, propName)
}

export function getTableFields (target: SchemerModel) : FieldConfigsOutput {
  const propNames = Reflect.getMetadata(TABLE_FIELDS, target) || []
  const output = {}
  propNames.forEach((propName: string) => {
    output[propName] = getFieldConfig(target, propName)
  })

  return output
}

export function getTableColumns (target: SchemerModel) : ColumnsConfig {
  const tableFields = getTableFields(target)

  return Object.keys(tableFields).reduce((out,key) => {
    // out[key] = tableFields[key].table

    return out.set(
      key, 
      (!tableFields[key].table || typeof tableFields[key].table === 'boolean') ? DEFAULT_TABLE_CONFIG : tableFields[key].table
    )
  }, new Map())
}

export function getTableHeader (target: SchemerModel, propName: string) {
  const config = getFieldConfig(target, propName)
  const tableConfig = config.table

  if (typeof tableConfig === 'object' && typeof tableConfig.header === 'function') {
    return tableConfig.header
    // typeof header === 'function' ? header() : header
  }
  // else {
  //   return config.label || propName
  // }
  return config.label //|| propName
}


const defaultFormatter = (v: any) => v ? `${v}` : null

export function getDisplayFormatter (target: SchemerModel, propName: string) {
  const config = getFieldConfig(target, propName)

  return config.formatDisplay || defaultFormatter //(target[propName])
}

export function getType (target: SchemerModel, propName: string) {
  const config = getFieldConfig(target, propName)

  return config.$type
}

export function getSubtype (target: SchemerModel, propName: string) {
  const config = getFieldConfig(target, propName) as ArrayConfigOutput
  if (config.$type !== ARRAY) {
    throw "No subtype for non-ARRAY type"
  }
  return config.$arrayOfType
}